import { Button } from "@/components/ui/button";
import { Calculator } from "lucide-react";
import { useNotify, useRecordContext, useRefresh } from "ra-core";
import { useState } from "react";
import { useHasPermission } from "../../../rbac/useHasPermission";
import { processPayroll } from "./processPayroll";

export const ProcessPayrollButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const { hasPermission } = useHasPermission("process_payroll");
  const [loading, setLoading] = useState(false);

  if (
    !record ||
    !hasPermission ||
    !["draft", "processing"].includes(record.status)
  )
    return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      await processPayroll(record.id);
      notify("Payroll processed");
      refresh();
    } catch (error: any) {
      notify(error?.message || "Could not process payroll", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      size="sm"
      onClick={handleClick}
      disabled={loading}
      className="gap-2 btn-green-action"
    >
      <Calculator className="h-4 w-4" />
      Process
    </Button>
  );
};
